import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  HEADER_HEIGHT,
  MAX_PAGE_WIDTH,
  WEB_CONTENT_WIDTH,
} from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  headerWrapper: {
    backgroundColor: theme.palette.header.main,
    height: HEADER_HEIGHT,
    borderRadius: '0 0 10px 10px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    // boxShadow: `0px 5px 4px 0px #00000040`,
    zIndex: 1000,
    color: theme.palette.header.contrastText,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  headerContent: {
    height: `calc(${HEADER_HEIGHT} - 1px})`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: MAX_PAGE_WIDTH,
    width: '100%',
    gap: theme.spacing(4),
    padding: theme.spacing(0, 2.5),
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },

  leftPart: {
    display: 'flex',
    alignItems: 'center',
  },

  menuIcon: {},
  searchWrapper: {
    width: '100%',
    maxWidth: WEB_CONTENT_WIDTH,
  },

  globalSearch: {
    width: '100%',
  },

  rightPart: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(0.5),

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));
